import {Component, inject} from '@angular/core';
import {ModalService} from '../../../../services/modal.service';


@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent<T> {
  display = true;
  modalService = inject<ModalService<T>>(ModalService)

  close(data: any = null) {
    this.display = false;

    setTimeout(async () => {
      this.modalService.close();
      this.modalService.onClose.emit(data);
    }, 300);
  }
}
